// What un-sharing a dataset costs other people, as a sentence.
//
// Un-sharing is the quiet half of a dataset going away. Deleting at least feels
// destructive; flipping a dataset back to private reads like a settings change and
// had no confirmation at all — while breaking every widget a colleague built on it,
// with no notice to them.
//
// Your own widgets keep working, because you still own the dataset. Counting them
// here would overstate the damage, and a warning that overstates is one people
// learn to click past.

export function shareImpactMessage(others) {
  // Unknown is not zero. If the count could not be fetched we still say something
  // will break, because silently implying "nothing depends on this" is the failure
  // the whole dialog exists to prevent.
  if (others === null || others === undefined) {
    return '• Widgets other people built on it will stop working.';
  }
  if (others === 0) return '• No one else has widgets built on it.';
  if (others === 1) return '• 1 widget belonging to someone else will stop working.';
  return `• ${others.toLocaleString()} widgets belonging to other people will stop working.`;
}
